/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description No Content
 */
export const importTimesheetEntries204Schema = z.any();

export const importTimesheetEntriesMutationRequestSchema = z.object({
  employee: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  project: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable()
    .nullish(),
  entries: z.array(
    z.object({
      date: z.string().date().optional(),
      hours: z.coerce.number().optional(),
    }),
  ),
});

export const importTimesheetEntriesMutationResponseSchema = z.lazy(
  () => importTimesheetEntries204Schema,
);
